export type ReviewCommentDomain = "manual" | "parts";
export type ReviewCommentStatus = "open" | "resolved";

export interface ReviewComment {
  commentId: string;
  threadId: string;
  parentCommentId: string | null;

  masterAssemblyId: number;
  domain: ReviewCommentDomain;

  manualId?: number | null;
  sectionId?: string | null;
  blockId?: string | null;

  figId?: number | null;
  itemNumber?: number | null;

  userId: string;
  userName: string;

  message: string;

  status: ReviewCommentStatus;

  createdAt: string;

  resolvedBy?: string | null;
  resolvedAt?: string | null;
}

export interface CreateReviewCommentDto {
  masterAssemblyId: number;
  domain: ReviewCommentDomain;

  manualId?: number | null;
  sectionId?: string | null;
  blockId?: string | null;

  figId?: number | null;
  itemNumber?: number | null;

  userId: string;
  userName: string;
  message: string;
}

export interface ReplyReviewCommentDto {
  parentCommentId: string;

  sectionId?: string | null;
  blockId?: string | null;

  figId?: number | null;
  itemNumber?: number | null;

  userId: string;
  userName: string;
  message: string;
}

export interface ReviewCommentThread {
  threadId: string;
  rootComment: ReviewComment;
  replies: ReviewComment[];
}

export function isRootComment(comment: ReviewComment): boolean {
  return !comment.parentCommentId;
}

export function buildReviewCommentThreads(
  comments: ReviewComment[]
): ReviewCommentThread[] {
  const sorted = [...comments].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );

  const grouped = new Map<string, ReviewComment[]>();

  for (const comment of sorted) {
    const existing = grouped.get(comment.threadId) ?? [];
    existing.push(comment);
    grouped.set(comment.threadId, existing);
  }

  const threads: ReviewCommentThread[] = [];

  grouped.forEach((threadComments, threadId) => {
    const rootComment =
      threadComments.find((c) => c.commentId === threadId) ??
      threadComments.find((c) => !c.parentCommentId);

    if (!rootComment) return;

    const replies = threadComments.filter((c) => c.commentId !== rootComment.commentId);

    threads.push({
      threadId,
      rootComment,
      replies,
    });
  });

  return threads.sort(
    (a, b) =>
      new Date(a.rootComment.createdAt).getTime() -
      new Date(b.rootComment.createdAt).getTime()
  );
}